import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import habitReducer from '../features/Habit/reducer';
import checklistReducer from '../features/Checklist/reducer';
import weeklyPeriodReducer from '../features/WeeklyPeriod/reducer';
import currentDateReducer from '../features/CurrentDate/reducer';
import periodRangeReducer from '../features/PeriodRange/reducer';
import requestReducer from '../features/Request/reducer';


let allReducers = combineReducers({
   habits: habitReducer,
   checklists: checklistReducer,
   weeklyPeriod: weeklyPeriodReducer,
   periodRange: periodRangeReducer,
   currentDate: currentDateReducer,
   request: requestReducer,
});

const store = createStore(allReducers,applyMiddleware(thunk));

export default store;
